import { useEffect, useState } from "react";

const SecureImage = ({ url, token, alt }) => {
    const [src, setSrc] = useState("");
    useEffect(() => {
        let objectUrl;

        if (!url || !token) return;

        fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        })
            .then(res => {
                if (!res.ok) throw new Error("Unauthorized / Image not found");
                return res.blob();
            })
            .then(blob => {
                objectUrl = URL.createObjectURL(blob);
                setSrc(objectUrl);
            })


        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [url, token]);

    return src ? (
        <img
            src={src}
            alt={alt}
            loading="lazy"
            style={{ maxWidth: "100%" }}
        />
    ) : null;

};

export default SecureImage;
